import React, { useEffect, useState } from 'react';
import { Button, Icon, Paragraph, Textfield } from '@innovationnorway/cl-react';
import { useTranslation } from 'react-i18next';
import { useCluster } from 'src/features/cluster';
const CopyToClipboardComponent = ({ link }: { link: string }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { t: tCommon } = useTranslation('common');
  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isCopied]);
  return (
    <Button
      type="button"
      data-size="sm"
      aria-label={tCommon('copyLink')}
      onClick={() => {
        navigator.clipboard.writeText(link);
        setIsCopied(true);
      }}
    >
      <Icon className="margin-right--1" prefix="fasr" iconName={isCopied ? 'check' : 'copy'} />
      {isCopied ? tCommon('copied') : tCommon('copyLink')}
    </Button>
  );
};
const CreateLinkToOpportunityForm = () => {
  const { cluster } = useCluster();
  const { t: tOnboarding } = useTranslation('onboarding');
  const link = `https://raskavklaring.innovasjonnorge.no?cid=${cluster?.id}&return_to_actor=${true}&from_system=flerbedriftsportal.no`;

  return (
    <div className="stack-small">
      <Paragraph data-size="sm">{tOnboarding('entryLink.Step1.Note')}</Paragraph>
      <div className="display--flex flex-direction--column align-items--flex-start gap--ds-4">
        <Textfield
          className="align-self--stretch"
          readOnly
          value={link}
          aria-label={tOnboarding('entryLink.Step1.Label')}
          onFocus={(e) => e.target.select()}
        />
        <CopyToClipboardComponent link={link} />
      </div>
    </div>
  );
};
export default CreateLinkToOpportunityForm;
